<template>
  <div class="upload-popover">
    <el-popover
      ref="popover"
      v-model="isShow"
      placement="bottom-start"
      width="600"
      popper-style="padding:0;padding-top: 8px;"
      trigger="manual"
      :teleported="false"
      :show-arrow="false"
      popper-class="upload-popover--popover"
    >
      <div v-click-outside="onClickOutside" class="upload-box">
        <div v-if="resetData" class="popover-list">
          <div v-for="item in files" :key="item.id || item.uid" class="item" @click.stop="showImg(item)">
            <div class="item-in">
              <div class="top">
                <div class="top-left">
                  <img :src="getIconType(item)" alt="" />
                  <toolTip :title="item.attachment_name || item.name" maxWidth="80%">
                    <span>{{ item.attachment_name || item.name }}</span>
                  </toolTip>
                </div>
                <div class="top-right">
                  <span v-if="item.percentage < 100">{{ item.percentage }}%</span>
                  <span v-else class="fileSize">{{ getfilesize(item.size) }}</span>
                  <span v-if="!disabled" class="close tableIconHover" @click.stop="removeFile(item)"
                    ><i class="icon iconfont iconicon_close1"></i
                  ></span>
                </div>
              </div>
              <div v-if="item.percentage < 100" class="el-progress-custom">
                <el-progress :percentage="item.percentage" :show-text="false"></el-progress>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!disabled" class="upload-btn">
          <span class="text-btn-active" @click.stop="btnUpload">
            <i class="icon iconfont iconicon_enlarge" style="margin-right: 6px"></i>
            附件上传
          </span>
        </div>
      </div>
      <template #reference>
        <div class="btn-box">
          <div
            class="btn"
            :class="{ 'no-data': !isHasData, 'is-disabled': disabled, 'is-table': table }"
            @click.stop="uploadFn"
          >
            <div v-if="isHasData" class="file-list">
              <div v-for="item in files" :key="item.id || item.uid" class="item">
                <div class="left">
                  <img :src="getIconType(item)" alt="" />
                  <toolTip :title="item.attachment_name || item.name" maxWidth="140px">
                    <span>{{ item.attachment_name || item.name }}</span>
                  </toolTip>
                </div>
                <div class="right" v-if="!disabled" @click.stop="removeFile(item)">
                  <i class="icon iconfont iconicon_close1"></i>
                </div>
              </div>
            </div>
            <div v-if="isHasData && !table" class="arrow" @click.stop="showPopover">
              <i class="icon iconfont iconicon_arrow_task" :class="{ 'is-reverse': isShow }"></i>
            </div>
            <span v-else-if="!disabled" class="tip">
              <i class="icon iconfont iconicon_enlarge" style="margin-right: 7px"></i>
              附件上传
            </span>
            <span v-else-if="!isHasData && disabled" class="tip"> 无 </span>
          </div>
        </div>
      </template>
    </el-popover>
    <Upload
      ref="upload"
      v-bind="$props"
      @onUploadProgress="uploadProgress"
      @cancel="cancelAndremoveFile"
      v-if="!disabled"
    ></Upload>
  </div>
</template>
<script>
import Upload from '@/components/uploadOss'
const clickOutside = {
	bind(el, binding) {
		// 在元素上绑定一个点击事件监听器
		el.clickOutsideEvent = function (event) {
			// 检查点击事件是否发生在元素的内部
			if (!(el === event.target || el.contains(event.target))) {
				// 如果点击事件发生在元素的外部，则触发指令绑定的方法,将点击的event数据传过去
				binding.value(event);
			}
		};
		// 在文档上添加点击事件监听器
		document.addEventListener('click', el.clickOutsideEvent);
	},
	unbind(el) {
		// 在元素上解除点击事件监听器
		document.removeEventListener('click', el.clickOutsideEvent);
	},
}
export default {
  components: { Upload },
  directives: {
		'click-outside': clickOutside, // 注册自定义指令
	},
  props: {
    value: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    table: {
      type: Boolean,
      default: false,
    },
    //是否支持多选文件
    multiple: {
      type: Boolean,
      default: true,
    },
    //是否启用拖拽上传
    drag: {
      type: Boolean,
      default: false,
    },
    //已上传文件列表
    fileList: {
      type: Array,
      default: () => [],
    },
    //上传的接口名
    apiName: {
      type: String,
      default: 'getAirportAttachmentPolicy',
    },
    // 附件上传type
    uploadType: {
      type: Number,
      default: 1,
    },
    // 限制只能上传一个文件
    limitOne: {
      type: Boolean,
      default: false,
    },
    acceptType: {
      type: String,
      default:
        '.jpg, .jpeg, .png, .bmp, .doc, .gif, .svg, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt ., .mp4, .avi, .f;v, .wav, .mpeg, .mov, .dat, .mpg, .zip, .rar, .tar',
    },
    //文件大小限制（单位为kb）
    fileSize: {
      type: Number,
      default: 100, //(500M)
    },
    upload_type: {
      //上传类型  ordinary（普通附件），database（资料库） , cross(跨团队项目), product (产品数据)
      type: String,
      default: "ordinary",
    },
  },
  data() {
    return {
      isUploadArr: [],
      isShow: false,
      resetData: true,
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || []
      },
      set: function (newValue) {
        this.$emit('input', newValue || [])
      },
    },
    files() {
      const current = this.currentValue.slice()
      return [...current, ...this.isUploadArr]
    },
    isHasData() {
      const current = this.currentValue.slice()
      return [...current, ...this.isUploadArr].length > 0
    }
  },
  methods: {
    onClickOutside() {
      this.hide()
    },
    uploadFn() {
      if (this.isHasData) {
        this.isShow = !this.isShow
        return
      }
      this.btnUpload()
    },
    btnUpload() {
      if (this.disabled) return
      this.$refs['upload'].$el.getElementsByClassName('el-upload__input')[0].click()
      this.show()
    },
    uploadProgress(file) {
      if (!this.isHasData) {
        this.show()
      }
      let idx = this.isUploadArr.findIndex((res) => res.id == file.id)
      if (idx > -1) {
        this.isUploadArr.splice(idx, 1, file)
      } else {
        this.isUploadArr.push(file)
      }
      if (file.percentage === 100) {
        file.visible = false
        file.sort = this.currentValue.length
        // 如果只能上传一个文件
        if (!this.multiple) {
          this.currentValue = [file]
          this.isUploadArr.splice(idx, 1)
        } else {
          this.currentValue.push(file)
          this.isUploadArr.splice(idx, 1)
        }
      }
      console.log('-----------', this.currentValue)
      this.resetData = false
      this.$nextTick(() => {
        this.resetData = true
      })
    },
    getIconType(file) {
      let type = file.uid
        ? file.name.substr(file.name.lastIndexOf('.') + 1)
        : file.attachment_type || file.type
      return this.getFileTypeUrl(type)
    },
    show() {
      this.isShow = true
    },
    hide() {
      this.isShow = false
    },
    async removeFile(item) {
      if (item.percentage < 100) {
        item.source.cancel('取消上传')
        let index = this.isUploadArr.findIndex((res) => res.id == item.id)
        this.isUploadArr.splice(index, 1)
      } else {
        let index = this.currentValue.findIndex((res) => res.id == item.id)
        this.currentValue.splice(index, 1)
      }
    },
    cancelAndremoveFile(item) {
      this.hide()
      this.removeFile(item)
    },
    showImg(item) {
      this.getOssUrl(item?.oss_attachment_name, (data) => {
        this.opendImgUrl(item?.attachment_type, data.sign_url)
      })
    },
    showPopover() {
      this.isShow = !this.isShow
    }
  },
}
</script>
<style lang="scss">
.upload-popover {
  .btn-box {
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
  }
  .btn {
    cursor: pointer;
    height: 100%;
    width: 0;
    flex: 1;
    border-radius: 8px;
    border: 1px solid rgba(32, 32, 32, 0.16);
    display: flex;
    padding-right: 1px;
    overflow: hidden;
    padding-right: 40px;
    position: relative;
    &:hover {
      border: 1px solid rgba(32, 32, 40, 0.6);
      .tip {
        color: #202020;
      }
    }
    &:focus {
      border: 1px solid #0D70E8;
    }
    .arrow {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      right: 14px;
      line-height: 1;
      top: 50%;
      transform: translate(0, -50%);
      color: rgba(26, 26, 26, 0.6);
    }
  }
  .no-data,
  .is-disabled {
    border-radius: 8px;
  }
  .no-data.is-disabled {
    pointer-events: none;
  }
  .is-table {
    border: 0 none !important;
  }

  .tip {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: rgba(26, 26, 26, 0.6);
    height: 100%;
    width: 100%;
  }
  .tip-btn {
    width: 97px;
    border: 1px solid rgba(26, 26, 26, 0.16);
    border-radius: 0 8px 8px 0;
    border-left: 0 none;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: rgba(26, 26, 26, 0.6);
    i {
      margin-right: 7px;
    }
  }
  .EHUpload-container {
    display: none;
  }
  .file-list {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 8px;
    position: relative;
    width: 0;
    flex: 1;
    overflow: hidden;

    .item {
      height: 28px;
      background-color: rgba(26, 26, 26, 0.08);
      border-radius: 4px;
      font-size: 14px;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 8px;
      margin-right: 8px;
      flex-shrink: 0;
      max-width: 200px;
      img {
        width: 18px;
        margin-right: 8px;
      }
    }
    .left {
      display: flex;
      align-items: center;
    }
    .right {
      width: 28px;
      height: 28px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 12px;
      }
      &:hover {
        background-color: rgba(32, 32, 32, 0.06);
      }
    }
  }


}
.upload-popover--popover {
  .upload-box {
    .upload-btn {
      height: 60px;
      border-top: 1px solid rgba(26, 26, 26, 0.08);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      i {
        font-size: 14px;
      }
    }
  }
  .el-progress-custom {
    margin: 0 auto;
    width: 100%;
    margin-top: 16px;
    margin-bottom: 6px;
    span {
      font-size: 12px;
    }
    .el-progress-bar__outer {
      height: 6px !important;
    }
  }
  .popover-list {
    .item {
      padding: 0 16px;
      cursor: pointer;
      &:hover {
        background-color: #ededed;
        .close {
          display: block !important;
        }
        .fileSize {
          display: none;
        }
      }
      &:last-child .item-in {
        border: 0 none;
      }
    }
    .item-in {
      border-bottom: 1px solid rgba(26, 26, 26, 0.08);
      height: 100%;
      padding: 13px 0;
      box-sizing: border-box;
      img {
        width: 18px;
        margin-right: 8px;
      }
    }

    .top {
      min-height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .top-left {
      display: flex;
      align-items: center;
      width: 0;
      flex: 1;
    }
    .top-right {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: rgba(26, 26, 26, 0.6);
      .close {
        margin-left: 19px;
        display: none;
        line-height: 1;
        i {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
